// Review sol üst şeridi — Bölümler / Tutarlılık sekme düğmeleri.
import { REPORT_CHECK_COPY } from "../../lib/report-check-copy";

export type ReviewTab = "sections" | "consistency";

export function ReportCheckTabSwitch({
  tab,
  onChange,
}: {
  tab: ReviewTab;
  onChange: (t: ReviewTab) => void;
}): JSX.Element {
  const items: [ReviewTab, string][] = [
    ["sections", REPORT_CHECK_COPY.sectionsTab],
    ["consistency", REPORT_CHECK_COPY.tab],
  ];
  return (
    <div role="tablist" className="mt-2 mb-2 flex gap-1">
      {items.map(([k, label]) => (
        <button
          key={k}
          role="tab"
          aria-selected={tab === k}
          onClick={() => onChange(k)}
          className="px-3 py-1 rounded-md text-xs"
          style={{
            fontWeight: 600,
            background: tab === k ? "var(--color-bg)" : "transparent",
            color: tab === k ? "var(--color-primary)" : "var(--color-text-3)",
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
